// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2P0bG","title":"style_title__3Ikur"};